import styled from 'styled-components';
import { positions } from 'utils/styles';

export const ComponentModal = styled.div.attrs({
    className: 'component-modal',
})`
    overflow: auto;
    position: fixed;
    ${positions(0, 0, 0, 0)}
    width: 100%;
    z-index: 1290;

    ion-content {
        --background: transparent;
        --color: #444;
    }
`;

export const ComponentModalBackdrop = styled.div.attrs({
    className: 'component-modal-backdrop',
    tabindex: -1,
})`
    background: rgba(255, 255, 255, 0.9);
    height: 100%;
    position: absolute;
    ${positions(0, 'auto', 'auto', 0)}
    width: 100%;
    z-index: -1;
`;

export const ComponentModalContents = styled.div.attrs({
    className: 'component-modal-contents',
})``;

export const ModalContainer = styled.div.attrs({
    className: 'component-modal-container container',
})`
    flex: 1 1 auto;
    padding: 0 1.5rem;
    padding-bottom: calc(1.5rem + var(--ion-safe-area-top));
    position: relative;
`;
